import React, { useState } from 'react';

import TextField from '@material-ui/core/TextField';

import { validateEmail } from '../../businesslogic/form-validators';
import { UiButton } from '../../ui/ui-button';

type AddCustomEmailButtonProps = {
  onSubmit: (email: string) => void;
};

export const AddCustomEmailButton = ({ onSubmit }: AddCustomEmailButtonProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [textFieldValue, setTextFieldValue] = useState('');

  const enableEditing = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setTextFieldValue('');
    setIsEditing(false);
  };

  const handleSubmit = () => {
    onSubmit(textFieldValue);
    setTextFieldValue('');
    setIsEditing(false);
  };

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = ({ target: { value } }) => {
    setTextFieldValue(value);
  };

  // Enter submits the whole form instead of just this textfield
  const disableEnter: React.KeyboardEventHandler<HTMLDivElement> = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const emailError = validateEmail(textFieldValue);
  const hasErrors = !textFieldValue.length || !!emailError;

  return isEditing ? (
    <>
      <div className="u-flex-center u-width-fitContent">
        <TextField
          label="New Email"
          onChange={handleChange}
          value={textFieldValue}
          variant="outlined"
          margin="dense"
          autoFocus
          error={Boolean(emailError)}
          onKeyDown={disableEnter}
        />
        <UiButton
          onClick={handleSubmit}
          className="u-margin-left-sm u-margin-right-sm"
          size="sm"
          disabled={hasErrors}
        >
          Add
        </UiButton>
        <UiButton variant="dismiss" size="sm" onClick={handleCancel}>
          Cancel
        </UiButton>
      </div>
      <div className="typo-subtitle u-color-red">{emailError}</div>
    </>
  ) : (
    <UiButton onClick={enableEditing}>Add Email</UiButton>
  );
};
